module.exports = __webpack_public_path__ + "static/media/surveySmiley.ecde395c.png";